import { type HeaderContext } from "@tanstack/react-table";

import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import React, { useMemo } from "react";
import { isMobile } from "react-device-detect";
import "../Table.scss";

interface HyperTableHeaderProps<Entity>
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  headerContext: HeaderContext<Entity, unknown>;
  caption: React.ReactNode | (() => React.ReactNode);
}

export function HyperTableHeader<Entity>(props: HyperTableHeaderProps<Entity>) {
  const { headerContext, caption } = props;

  const finalCaption = useMemo(
    () => (typeof caption === "function" ? caption() : caption),
    [caption],
  );

  return (
    <Button
      className="table-header-title"
      title={typeof finalCaption === "string" ? finalCaption : undefined}
      sx={{
        minWidth: 0,
        flex: 1,
        overflow: "hidden",
        fontSize: isMobile ? "small" : undefined,
        textTransform: "unset",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 0.25,
        py: 0.25,
        whiteSpace: "normal",
      }}
      onClick={() => headerContext.column.toggleSorting()}
      disabled={!headerContext.column.getCanSort()}
    >
      <Box
        component="span"
        sx={{
          minWidth: 0,
          flex: 1,
          overflow: "hidden",
          textAlign: "start",
          lineHeight: 1.25,
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          wordBreak: "break-word",
        }}
      >
        {finalCaption}
      </Box>
      {headerContext.column.getCanSort() &&
      headerContext.column.getIsSorted() === "desc" ? (
        <ArrowDropUp aria-hidden="true" sx={{ flexShrink: 0 }} />
      ) : (
        headerContext.column.getCanSort() &&
        headerContext.column.getIsSorted() === "asc" && (
          <ArrowDropDown aria-hidden="true" sx={{ flexShrink: 0 }} />
        )
      )}
    </Button>
  );
}
